import { combineReducers } from 'redux';
import Create from './create.reducer';
import List from './list.reducer';
import Delete from './delete.reducer';

export default combineReducers({ Create, List, Delete });
